import { createAction, props } from '@ngrx/store';

import { SearchForm } from '../../models/searchFormDto';

export const setSearchForm = createAction(
    '[ServiceRequest API] Set SearchForm',
    props<{searchForm: SearchForm}>()
);